function extractVimeoId(input) {
    if (!input) return null;

    // If it's just a number, return it
    if (/^\d+$/.test(input)) {
        return input;
    }

    // Try to extract from Vimeo URL
    const patterns = [
        /vimeo\.com\/(\d+)/,
        /vimeo\.com\/video\/(\d+)/,
        /player\.vimeo\.com\/video\/(\d+)/
    ];

    for (const pattern of patterns) {
        const match = input.match(pattern);
        if (match) {
            return match[1];
        }
    }

    return input;
}

function initBlockVideo() {
    const blockVideos = document.querySelectorAll('.block-video');

    blockVideos.forEach(block => {
        const link = block.querySelector('a[data-modal-vimeo-id]');
        const cursor = block.querySelector('.custom-cursor');

        if (!link) return;

        if (cursor) {
            const updateCursor = function(e) {
                cursor.style.left = e.clientX + 'px';
                cursor.style.top = e.clientY + 'px';
            };

            link.addEventListener('mousemove', updateCursor);
        }

        link.addEventListener('click', function(e) {
            e.preventDefault();
            const vimeoInput = link.getAttribute('data-modal-vimeo-id');
            const vimeoId = extractVimeoId(vimeoInput);

            if (vimeoId && typeof openVimeoModal === 'function') {
                openVimeoModal(vimeoId, 'block-video');
            } else {
                console.error('Could not open Vimeo modal:', { vimeoInput, vimeoId, openVimeoModal: typeof openVimeoModal });
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlockVideo);
} else {
    initBlockVideo();
}
